
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'

@Component({
  components: {}
})
export default class extends Vue {
  @Prop({ default: 0 }) activeIndex: number
  @Prop({ default: () => [] }) data: unknown[][]

  hoverPrev: boolean = false

  hoverNext: boolean = false

  @Emit('prev')
  prev() {}

  @Emit('next')
  next() {}

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
